<template>
  <div class="modal" tabindex="-1">
    <div class="modal-content">
      <div class="row" style="padding: 0; margin: 0">
        <v-layout row="wrap" align-center px-4 py-3 mb-5>
          <v-flex
            shrink
            class="title-text"
            style="font-size: 27px !important; color: #a6cc39"
          >
            {{ $t(title) }}
          </v-flex>
          <v-spacer />
          <v-flex shrink>
            <img
              alt
              src="@/assets/imgs/close.jpg"
              style="width: 16px; height: 16px; cursor: pointer"
              @click="close"
            />
          </v-flex>
        </v-layout>
        <div
          class="col-lg-12 form-group"
          style="border-bottom:2px solid #A6CC39;color:#185B2C;padding:0px;8px;"
        >
          <h5 class="title-text" style="color: #a6cc39">
            {{ $t("generalinformation") }}
          </h5>
        </div>
        <!-- Title -->
        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputCompany" class="b-text">
            {{ $t("companyname") }}
          </label>
          <input
            type="text"
            ref="companyName"
            class="form-control"
            style="
              border: 1px solid #f3f4f5;
              border-radius: 10px;
              background-color: #f3f4f5;
              height: 45px;
            "
            readonly
            id="inputCompany"
            :placeholder="localeCompanyName()"
            v-model="companyName"
          />
          <div v-if="namecheck" style="color: red">
            {{ $t("companyname") }} is required
          </div>
          <div v-if="checkalphabet2 == true" style="color: red">
            Please fill in Alphabet.
          </div>
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputCompany" class="b-text">{{ $t("abbre") }}</label>
          <input
            type="text"
            class="form-control"
            style="
              border: 1px solid #f3f4f5;
              border-radius: 10px;
              background-color: #f3f4f5;
              height: 45px;
            "
            readonly
            :placeholder="localeAbbreviation()"
            @keydown="checkAlphabet"
            v-model="abbreviation"
          />
          <div v-if="checkalphabet == true" style="color: red">
            Please fill in Alphabet.
          </div>
          <div v-if="abbrevCheck" style="color: red">
            {{ $t("abbre") }} is required.
          </div>
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputTelephone" class="b-text">
            {{ $t("telephoneno") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="inputTelephone"
            style="
              border: 1px solid #f3f4f5;
              border-radius: 10px;
              background-color: #f3f4f5;
              height: 45px;
            "
            readonly
            :placeholder="localeTelephone()"
            @keydown="isNumber($event)"
            v-model="telephoneNumber"
            v-mask="'###########'"
          />
          <div v-if="checknumber == true" style="color: red">
            Please fill in Number.
          </div>
          <div v-if="phonecheck" style="color: red">
            {{ $t("telephoneno") }} is required.
          </div>
          <div v-if="phonenolength" style="color: red">
            {{ $t("enterphno") }}
          </div>
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputEmail" class="b-text">{{ $t("email") }}</label>
          <input
            type="text"
            class="form-control"
            style="
              border: 1px solid #f3f4f5;
              border-radius: 10px;
              background-color: #f3f4f5;
              height: 45px;
            "
            readonly
            id="inputEmail"
            :placeholder="localeEmail()"
            v-model="email"
          />
          <div v-if="mailcheck" style="color: red">
            Please enter correct {{ $t("email") }}
          </div>
          <span v-if="!echeck1" style="color: red"
            >{{ $t("email") }} already exist</span
          >
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputCountry" class="b-text">{{ $t("country") }}</label>
          <input
            type="text"
            class="form-control"
            style="
              border: 1px solid #f3f4f5;
              border-radius: 10px;
              background-color: #f3f4f5;
              height: 45px;
            "
            readonly
            id="inputCountry"
            :placeholder="localeCountry()"
            v-model="countryName"
          />
          <div v-if="countrycheck" style="color: red">
            {{ $t("country") }} is required
          </div>
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputCity" class="b-text">{{ $t("city") }}</label>
          <input
            type="text"
            class="form-control"
            style="
              border: 1px solid #f3f4f5;
              border-radius: 10px;
              background-color: #f3f4f5;
              height: 45px;
            "
            readonly
            id="inputCity"
            :placeholder="localeCity()"
            v-model="cityName"
          />
          <div v-if="citycheck" style="color: red">
            {{ $t("city") }} is required
          </div>
        </div>
        <!-- Detail -->
        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputAddress" class="b-text">{{ $t("address") }}</label>
          <input
            type="text"
            class="form-control"
            style="
              border: 1px solid #f3f4f5;
              border-radius: 10px;
              background-color: #f3f4f5;
              height: 45px;
            "
            readonly
            id="inputAddress"
            :placeholder="localeAddress()"
            v-model="address"
          />
          <div v-if="addresscheck" style="color: red">
            {{ $t("address") }} is required
          </div>
        </div>
        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label class="b-text">{{ $t("contactname") }}</label>
          <input
            type="text"
            style="
                border: 1px solid #f3f4f5;
                border-radius: 10px;
                background-color: #f3f4f5;
                height: 45px;
              "
            v-model="contactName"
            readonly
            class="form-control"
          />
          <label class="b-text">{{ $t("priceplan") }}</label>
          <input
            type="text"
            v-if="pricePlan == 1"
            class="form-control"
            style="
              border: 1px solid #f3f4f5;
              border-radius: 10px;
              background-color: #f3f4f5;
              height: 45px;
            "
            readonly
            :value="$t('basicplan')"
          />
          <input
            type="text"
            v-else
            class="form-control"
            style="
              border: 1px solid #f3f4f5;
              border-radius: 10px;
              background-color: #f3f4f5;
              height: 45px;
            "
            readonly
            :value="$t('enterpriseplan')"
          />
          <div v-if="priceplancheck" style="color: red">
            {{ $t("priceplan") }} is required
          </div>
        </div>
      </div>
      <!-- User Information -->
      <div class="clear my-5 pb-4">
        <div
          class="col-lg-12 form-group clear mt-2"
          style="border-bottom:2px solid #A6CC39;color:#D6C583;padding:0px;"
        >
          <h5 class="title-text" style="color: #a6cc39">
            {{ $t("logincredentials") }}
          </h5>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 pr-5 clear mt-3">
            <div class="col form-group clear mt-2 ml-2 pr-3 pl-4">
              <label class="b-text" for="inputUserID">{{ $t("userid") }}</label>
              <input
                type="text"
                class="form-control"
                style="
                  border: 1px solid #f3f4f5;
                  border-radius: 10px;
                  background-color: #f3f4f5;
                  height: 45px;
                "
                readonly
                id="inputUserID"
                v-model="userName"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#FFF4EB" dark>
        <v-card-text class="black--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#03391F"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ModalSuccess
      :isSuccessModalVisible="isSuccessModalVisible"
      image="employee"
      :text="text"
    />
    <ModalWarning
      :warningModal="warningModal"
      @warningModalUpdate="warningModal = warningModalUpdate"
    />
  </div>
</template>

<script>
import GlobalMixin from "../Mixins/GlobalMixin";
import ModalSuccess from "../../components/ModalSuccess";
import ModalWarning from "../../components/ModalWarning";
import axios from "axios";
import enurl from "@/api/environment";
import $ from "jquery";
export default {
  components: { ModalSuccess, ModalWarning },
  mixins: [GlobalMixin],
  name: "Modal",
  props: {
    title: String,
    companyId: String,
    companyName: String,
    telephoneNumber: String,
    email: String,
    editEmail: String,
    countryName: String,
    cityName: String,
    address: String,
    status: Boolean,
    userName: String,
    userID: Number,
    password: String,
    empID: String,
    abbreviation: String,
    check1: Boolean,
    companyIndex: String,
    pricePlan: Number,
    contactName: String
  },
  data: () => ({
    show1: false,
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match"
    },
    url: enurl.apiUrl,
    warningModal: false,
    isSuccessModalVisible: false,
    text: null,
    dialog: false,
    password2: null,
    namecheck: false,
    phonecheck: false,
    mailcheck: false,
    countrycheck: false,
    priceplancheck: false,
    citycheck: false,
    addresscheck: false,
    abbrevCheck: false,
    checkalphabet: false,
    checkalphabet2: false,
    checknumber: false,
    // pricePlan: null,
    phonenolength: false,
    echeck1: true
  }),
  watch: {
    abbreviation: function() {
      let self = this;

      if (
        self.abbreviation != 0 &&
        self.abbreviation != 1 &&
        self.abbreviation != 2 &&
        self.abbreviation != 3 &&
        self.abbreviation != 4 &&
        self.abbreviation != 5 &&
        self.abbreviation != 6 &&
        self.abbreviation != 7 &&
        self.abbreviation != 8 &&
        self.abbreviation != 9
      ) {
        let tempKey = self.abbreviation;
        axios
          .post(`${self.url}Company/CheckAbbre?abbre=${tempKey}`)
          .then(function(response) {
            if (response.data.status == 0) {
              self.check1 = true;
            } else {
              self.check1 = false;
            }
          })
          .catch(function(error) {
            alert(error);
          });
      }
    },
    email: function() {
      let self = this;
      self.echeck1 = true;
      if (
        self.email != "" &&
        self.email != null &&
        self.editEmail != self.email
      ) {
        let tempKey = self.email;
        axios
          .post(`${self.url}Login/CheckMail?email=${tempKey}`)
          .then(function(response) {
            self.echeck1 = response.data.data;
          })
          .catch(function(error) {
            alert(error);
          });
      }
    }
  },

  methods: {
    isNumber(e) {
      this.checknumber = false;
      // Allow: backspace, delete, tab, escape, enter and .
      if (
        $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190, 17, 18, 16]) !== -1 ||
        // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
        ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67) &&
          (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        this.checknumber = true;
        this.phonecheck = false;
        this.phonenolength = false;
        e.preventDefault();
      }
    },
    checkAlphabet(event) {
      let letterNumber = /^[a-zA-Z]+$/;
      if (event.key.match(letterNumber)) {
        this.checkalphabet = false;
      } else {
        this.checkalphabet = true;
      }
    },

    close() {
      this.$emit("close");
      this.checkalphabet2 = false;
      this.namecheck = false;
      this.checkalphabet = false;
      this.abbrevCheck = false;
      this.checkalphabet = false;
      this.checknumber = false;
      this.phonecheck = false;
      this.phonenolength = false;
      this.mailcheck = false;
      this.countrycheck = false;
      this.citycheck = false;
      this.addresscheck = false;
      this.priceplancheck = false;
    },
    validateEmail(email) {
      console.log(email);
    },
    CheckValidate() {
      let self = this;
      self.namecheck = true;
      self.phonecheck = true;
      self.checknumber = false;
      self.countrycheck = true;
      self.priceplancheck = true;
      self.mailcheck = true;
      self.citycheck = true;
      self.addresscheck = true;
      self.abbrevCheck = true;

      let retvalue = true;
      if (self.companyName != "" && self.companyName != undefined) {
        self.namecheck = false;
      } else {
        retvalue = false;
      }
      if (self.abbreviation != "" && self.abbreviation != undefined) {
        self.abbrevCheck = false;
      } else {
        retvalue = false;
      }
      if (self.telephoneNumber != "" && self.telephoneNumber != undefined) {
        if (self.telephoneNumber.length < 9) {
          self.phonenolength = true;
          retvalue = false;
        }
        self.phonecheck = false;
      } else {
        self.phonenolength = false;
        self.phonecheck = true;
        retvalue = false;
      }
      if (self.email != "" && self.email != undefined) {
        self.mailcheck = false;
        let aa = self.validateEmail(self.email);
        if (!aa) {
          retvalue = false;
          self.mailcheck = true;
        }
      } else {
        retvalue = false;
      }
      if (self.countryName != "" && self.countryName != undefined) {
        self.countrycheck = false;
      } else {
        retvalue = false;
      }
      if (self.pricePlan != null && self.pricePlan != undefined) {
        self.priceplancheck = false;
      } else {
        retvalue = false;
      }
      if (self.cityName != "" && self.cityName != undefined) {
        self.citycheck = false;
      } else {
        retvalue = false;
      }
      if (self.address != "" && self.address != undefined) {
        self.addresscheck = false;
      } else {
        retvalue = false;
      }
      if (self.echeck1 === false) {
        retvalue = false;
      }
      return retvalue;
    },
    CheckValidate1() {
      let self = this;
      self.namecheck = true;
      self.phonecheck = true;
      self.checknumber = false;
      self.countrycheck = true;
      self.priceplancheck = true;
      self.mailcheck = true;
      self.citycheck = true;
      self.addresscheck = true;
      self.abbrevCheck = true;
      let retvalue = true;
      if (self.companyName != "" && self.companyName != undefined) {
        self.namecheck = false;
      } else {
        retvalue = false;
      }
      if (self.telephoneNumber != "" && self.telephoneNumber != undefined) {
        if (self.telephoneNumber.length < 9) {
          self.phonenolength = true;
          retvalue = false;
        }
        self.phonecheck = false;
      } else {
        self.phonenolength = false;
        self.phonecheck = true;
        retvalue = false;
      }
      if (self.abbreviation != "" && self.abbreviation != undefined) {
        self.abbrevCheck = false;
      } else {
        retvalue = false;
      }
      if (self.email != "" && self.email != undefined) {
        self.mailcheck = false;
        let aa = self.validateEmail(self.email);
        if (!aa) {
          retvalue = false;
          self.mailcheck = true;
        }
      } else {
        retvalue = false;
      }
      if (self.countryName != "" && self.countryName != undefined) {
        self.countrycheck = false;
      } else {
        retvalue = false;
      }
      if (self.pricePlan != null && self.pricePlan != undefined) {
        self.priceplancheck = false;
      } else {
        retvalue = false;
      }
      if (self.cityName != "" && self.cityName != undefined) {
        self.citycheck = false;
      } else {
        retvalue = false;
      }
      if (self.address != "" && self.address != undefined) {
        self.addresscheck = false;
      } else {
        retvalue = false;
      }
      return retvalue;
    },
    localeCompanyName() {
      return this.$t("companyname");
    },
    localeAbbreviation() {
      return this.$t("abbre");
    },
    localeTelephone() {
      return this.$t("telephoneno");
    },
    localeEmail() {
      return this.$t("email");
    },
    localeCountry() {
      return this.$t("country");
    },
    localeCity() {
      return this.$t("city");
    },
    localeAddress() {
      return this.$t("address");
    },
    localeStatus() {
      return this.$t("status");
    }
  }
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  overflow-y: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 5% auto;
  padding: 30px 40px 15px 40px;
  border: 1px solid #888;
  width: 55%;
  border-radius: 25px;
}
@media only screen and (max-width: 600px) {
  .modal-content {
    width: 90%;
    padding: 30px 20px 15px 20px;
  }
}
.modal-content .close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.modal-content .close:hover,
.modal-content .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.form-group label {
  color: #43425d;
}
.form-group input,
.input-group input {
  /* color: rgba(77, 79, 92, 0.4);  */
  border: 1px solid #fff;
  background: #fff;
}
.form-group textarea,
.input-group textarea {
  /*  color: rgba(77, 79, 92, 0.4); */
  border: 1px solid #fff;
  background: #fff;
}

.review-box {
  position: relative;
  margin-left: 25px;
  margin-right: 15px;
  padding: 30px 40px;
  border: 1px solid #ecebee;
  font-size: 4rem;
  border-radius: 4px;
}
.review-box i {
  color: rgba(67, 66, 93, 0.2);
}
.review-box .close {
  position: absolute;
  top: -10px;
  right: -10px;
  float: right;
}
.review-box .close i {
  font-size: 28px;
  color: #eb2127;
}
.review-box .close:hover i {
  color: #eb2127;
}

.modal-footer button {
  outline: none;
}
select {
  border: 1px solid #fff;
  background: #fff;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  padding-left: 10px;
}
</style>
<style>
.modal {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.modal::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.v-input--selection-controls.v-input .v-label {
  margin-top: 8px !important;
}
</style>
